/**
 * Validation schemas using Yup for form validation
 * Reusable validation schemas across the application
 */
import * as Yup from "yup";

// Email validation schema
export const emailValidation = Yup.string()
  .email("Por favor ingresa un email válido")
  .required("El email es requerido");

// Password validation schema
export const passwordValidation = Yup.string()
  .required("La contraseña es requerida");

// Login form validation schema for both patients and providers
export const loginValidationSchema = Yup.object({
  email: emailValidation,
  password: passwordValidation,
});

// Individual field validations for more granular use
export const validationSchemas = {
  email: emailValidation,
  password: passwordValidation,
  login: loginValidationSchema,
};